<template>
    <div class="license-item column is-one-quarter">
      <div class="license-wrapper">
        <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteLicense(license.id)"/>
        <div class="license-photo-wrapper">
          <div class="license-photo is-flex centered" @click="handleLoadServicePhoto" v-if="!license.photo">
            <span class="button-wrapper">
              <a class="button is-info">+</a> Загрузить фото лицензии
            </span>
          </div>
          <div class="photo-container" v-else>
            <div v-if="license.photo || base64photo">
              <img :src='base64photo' v-if="base64photo" />
              <img :src='"/upload/photos/" + license.photo' v-else/>
            </div>
            <div>
              <span class="button-wrapper" @click="deletePhoto()">
                <img src="/static/img/icons/delete.svg" class="delete-icon"/>
                Удалить фото
              </span>
            </div>
          </div>
          <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton"/>
        </div>
        <div class="license-data">
            <b-input placeholder="Название лицензии" @change="handleUpdate" type="textarea" v-model="license.name"></b-input>
            <b-input placeholder="Номер лицензии" @change="handleUpdate" v-model="license.number"></b-input>
        </div>
        <div class="save-content-button centered">
          <button class="button save-content" @click="handleSaveLicense()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'LicenseItem',
  data () {
    return {
      updateTimer: null,
      base64photo: null,
      disabled: false
    }
  },
  props: {
    license: {
      required: true
    }
  },
  methods: {
    ...mapActions(['deleteLicense', 'loadLicensePhoto', 'updateLicense', 'addLicensePhoto', 'saveLicense']),
    handleUpdate () {
      clearTimeout(this.updateTimer)
      this.updateTimer = setTimeout(() => {
        this.updateLicense(this.license)
      }, 500)
    },
    loadPhoto (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('avatar', file)
      reader.onload = (e) => {
        this.license.photo = {
          data: formData
        }
        this.base64photo = e.target.result
        this.updateLicense(this.license)
      }
    },
    deletePhoto () {
      setTimeout(() => {
        this.license.photo = null
        this.base64photo = null
        this.updateLicense(this.license)
      })
    },
    handleLoadServicePhoto () {
      this.$refs.loadPhotoButton.click()
    },
    handleSaveLicense () {
      this.disabled = true
      this.saveLicense(this.license)
      .then(() => {
        this.disabled = false
        this.$toast.open({ message: 'Сохранено' })
      })
    }
  }
}
</script>

<style scoped>
.license-data p {
  margin: 10px 0;
}
.save-content {
  margin: 10px 0;
}
.license-wrapper {
  padding: 15px;
  border: 1px solid lightgray;
  text-align: center;
  position: relative;
}
.license-photo {
  height: 300px;
  background: #eee;
  cursor: pointer;
}
.photo-container {
  display: relative;
}
.photo-container .delete-icon {
  position: initial;
  margin: 0 8px 0 0;
}
.delete-icon {
  top: -5px;
  right: -5px;
}
</style>
<style>
.license-data textarea {
  min-height: 80px;
  max-height: 80px;
}
</style>



// WEBPACK FOOTER //
// LicenseItem.vue?12bcc840